import { addDays, format, isSameDay, startOfWeek } from 'date-fns';

export const getStartDate = (item: { start: Date | string }) =>
  typeof item.start === 'string' ? new Date(item.start) : item.start;

export const startDateToDateObject = <T extends { start: string }>(
  item: T
) => ({
  ...item,
  start: new Date(item.start),
});

export const endDateToDateObject = <T extends { end: string }>(item: T) => ({
  ...item,
  end: new Date(item.end),
});

export const isRecurringItem = ({ id }: { id: string }) => id.includes('#');

export const generateWeek = <T extends { start: Date }>(
  date: Date,
  items: T[]
) => {
  const monday = startOfWeek(date, { weekStartsOn: 1 });
  const tuesday = addDays(monday, 1);
  const wednesday = addDays(monday, 2);
  const thursday = addDays(monday, 3);
  const friday = addDays(monday, 4);
  const saturday = addDays(monday, 5);
  const sunday = addDays(monday, 6);

  return [
    getDayOfWeekData(monday, items),
    getDayOfWeekData(tuesday, items),
    getDayOfWeekData(wednesday, items),
    getDayOfWeekData(thursday, items),
    getDayOfWeekData(friday, items),
    getDayOfWeekData(saturday, items),
    getDayOfWeekData(sunday, items),
  ];
};

const getDayOfWeekData = <T extends { start: Date }>(
  date: Date,
  items: T[]
) => ({
  day_name: format(date, 'eeee'),
  date_text: format(date, 'd MMM'),
  items: items.filter((i) => isSameDay(i.start, date)),
});
